export {default as formatDefaultLocale, format, formatPrefix} from "./defaultLocale";
export {default as formatLocale} from "./locale";
export {default as formatSpecifier} from "./formatSpecifier";
export {default as precisionFixed} from "./precisionFixed";
export {default as precisionPrefix} from "./precisionPrefix";
export {default as precisionRound} from "./precisionRound";



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/index.js
// module id = 83
// module chunks = 0